import { ReactComponent as AddIcon } from "@src/styles/icon/add.svg";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../../../component/Desktop/loading/loading";
import TitlePage from "../../../component/Desktop/titlePage";
import {
  COMMON_CONSTANT,
  CONFIG,
  KEY,
  lang,
} from "../../../constants/common.const";
import {
  getQuerySearch,
  getTxtValue,
  handleCatchError,
  pushObject2Query,
  pushObject2QueryReplace,
  showMessage
} from "../../../constants/utils";

import classGrid from "../../../models/control/grid";
import classText from "../../../models/control/text";


import {
  ClearOutlined,
  DeleteOutlined,
  EditFilled,
  SearchOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { ApiDisaster } from "../../../api/backend/disaster";
import BoxContent from "../../../component/Desktop/content";
import routerConst from "../../../constants/router.const";
import { checkRoleScreen } from "../../../utils/roles";
import rolesConst from "../../../routers/roles/roles.const";

function Disaster_Category_List({ history: historyPage }) {
  const { roles } = useSelector((state) => state.auth);

  // check role
  const isHeadOfficeAdmin = roles == rolesConst.HEAD_OFFICE_ADMIN;

  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const objSearch = getQuerySearch();

  const { allowRoute } = useSelector((state) => state.auth);
  const location = useLocation();
  const history = useHistory();
  // Loading
  const [showLoading, setShowLoading] = useState(false);
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };
  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const [formSearch] = Form.useForm();

  //  Grid
  const [grid, setGrid] = useState(new classGrid());
  const [currentPage, setCurrentPage] = useState(objSearch.page || 1);
  const [txtTitle, setTxtTitle] = useState({
    ...new classText(),
    value: getTxtValue(objSearch.name),
  });

  // Search
  const search_onClick = async (init = true) => {
    try {
      setShowLoading(true);
      const response = await ApiDisaster.searchCategory({
        name: txtTitle.value ? txtTitle.value.trim() : null,
      });
      setGrid({ ...grid, data: response.data, count: response.data.length });
      if (!init) {
        setCurrentPage(1);
        pushObject2Query({
          name: txtTitle.value,
          page: 1,
        });
      } else {
        pushObject2Query({
          name: txtTitle.value,
          page: currentPage,
        });
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  // clearInputSearch
  const clearInputSearch = () => {
    setTxtTitle({...txtTitle,value:""})
    formSearch.resetFields();
    formSearch.submit();
  };

  // Column GRID
  const initColumns = [
    {
      title: lang.ID,
      dataIndex: "id",
      width: "10%",
      align: "center",
    },
    {
      title: <div className="">{lang.DISASTER_CATEGORY}</div>,
      dataIndex: "title",
      //  width: "25%",
      align: "center",
      render: (text, row) => {
        return (
          <Tooltip trigger={["hover"]} title={row.name}>
            <span
              className="underline"
              onClick={() =>
                history.push(
                  `${routerConst.ROUTER_PAGE.DISASTER_CATEGORY[3]}/${row.id}`
                )
              }
            >
              {row.name}
            </span>
          </Tooltip>
        );
      },
    },
   
  ];
  if(isHeadOfficeAdmin){
    initColumns.push( {
      title: lang.ACTION,
      align: "center",
      width: 180,
      render: (row) => {
        //
        return (
          <>
            {/* Edit */}
            <Tooltip title={lang.EDIT}>
              <Button className="mr5 btnEdit">
                <Link
                  to={
                    routerConst.ROUTER_PAGE.DISASTER_CATEGORY[2] + "/" + row.id
                  }
                  className="w100"
                >
                  <EditFilled className="" />
                </Link>
              </Button>
            </Tooltip>

            {/* Delete */}
            <Tooltip title={lang.DELETE}>
              <Button
                className="mr5 btnDelete"
                onClick={() => {
                  showMessageDeleteConfirm(row);
                }}
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </>
        );
      },
    },)
  }

  const showMessageDeleteConfirm = (rowData) => {
    // Action del
    const funcDel = async () => {
      openLoadingSpinner();

      // API Del
      try {
        // Close warning
        Modal.destroyAll();

        await ApiDisaster.deleteCategory(rowData.id);
        // API Search
        await search_onClick();

        // Open success
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
      } catch (ex) {
        handleCatchError(ex);
      }
      closeLoadingSpinner();
    };

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
    });
  };

  // Init
  useEffect(() => {
    if (checkRoleScreen(location.pathname, allowRoute)) {
      search_onClick();
    }
  }, [allowRoute]);

  // Render
  return (
    <div className="des-content">
      <TitlePage name={lang.DISASTER_CATEGORY_LIST} />
      <BoxContent
        style={{
          margin: isPC ? "24px 16px" : 0,
          padding: isPC ? 24 : "0 16px",
        }}
      >
        <Form
          layout={"vertical"}
          name="searchWR"
          form={formSearch}
          onFinish={() => search_onClick(false)}
          className="formStyle"
        >
          {/* 1 */}
          <Row gutter={[16, 8]} align="bottom" className="rowNotMargin">
            <Col lg={8} md={12} xs={24}>
              <div className="ant-form-item-label">
                {lang.DISASTER_CATEGORY}
              </div>
              <Input
                placeholder={lang.DISASTER_CATEGORY}
                value={txtTitle.value}
                maxLength={255}
                onChange={(e) =>
                  setTxtTitle({
                    ...txtTitle,
                    value: e.target.value,
                  })
                }
              />
            </Col>

            {/* Button Search/Clear */}
            <Col flex="none" className="right">
              <Row
                className="rowNotMargin mt10"
                gutter={[12, 12]}
                justify="start"
                align="bottom"
              >
                <Col
                  style={{
                    marginBottom: -5,
                  }}
                >
                  <Button
                    htmlType="submit"
                    className="buttonPC button--info wAuto"
                  >
                    <SearchOutlined className="" />
                    {lang.SEARCH}
                  </Button>
                </Col>
                <Col
                  style={{
                    marginBottom: -5,
                  }}
                >
                  <Button
                    className="buttonPC button--outline --todo-- wAuto ml10"
                    onClick={clearInputSearch}
                  >
                    <ClearOutlined />
                    {lang.CLEAR}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </BoxContent>

      <BoxContent
        style={{
          margin: isPC ? "24px 16px" : 0,
          padding: isPC ? 24 : "12px 24px",
        }}
      >
        {/* Count */}
        <Row justify="space-between ">
          <Col span={12}>
            {
              isHeadOfficeAdmin && <Button
              type="link"
             
              className="btnAddRecord mb15"
              onClick={() => {
                history.push(routerConst.ROUTER_PAGE.DISASTER_CATEGORY[1]);
              }}
            >
              <AddIcon />
              {lang.ADD}
            </Button>
            }
          </Col>
          <Col span={12} className="right">
            {/* Count */}
            <Space size={10} align="center ">
              {lang.ACCESS_NUMBERS}
              <span>
                {grid.count}
                {lang.CASE}
              </span>
            </Space>
          </Col>
        </Row>
        {/* Grid  */}

        <Table
          rowKey={(record) => record.id}
          className="gridSearch "
          columns={initColumns}
          dataSource={grid.data}
          pagination={{
            ...CONFIG.paging,

            current: Number(currentPage) || 1,
            onChange: (curr) => {
              setCurrentPage(curr);
              pushObject2QueryReplace({ page: curr });
            },
          }}
        />
      </BoxContent>
      <Loading show={showLoading}></Loading>
    </div>
  );
}
export default Disaster_Category_List;
